// Module
var code = "<h3>Email templates</h3> <div class=\"listingTableContainer\"> <table id=\"emailTemplatesTable\"> <thead id=\"emailTemplatesTableHead\"></thead> <tbody id=\"emailTemplatesTableBody\"></tbody> </table> </div> ";
// Exports
export default code;